import React from 'react';

const Main = () => {
	return (
		<div className="main-container">
			<h1 className="title">Crowdfunding for community projects you care about</h1>
			<div className="main-content">
				<div className="main-left">
				</div>
				<div className="main-right">
					<p>
						There’s a problem for people who are looking to get their trade license have time constraints
						and access to quality training that prevent them from a path to state licensure. This problem is
						highlighted in urban communities where they tend to work longer hours and juggle multiple
						responsibilities at home.
					</p>
					<p>
						By eliminating the lack of resources and opportunities problems that people in communities have,
						ReVitalize will give people who are seeking state licenses access to education and employment.
					</p>
					<p>
						ReVitalize uses a model, where students enter contracts with ReVitalize, to establish a pathway
						for them to obtain the resources and time necessary to become a self-sufficient and prospering
						trades professional. The resources shortfall include not only education and work opportunities
						created through the application, but also the ability to pay for life's general necessities.
						ReVitalize will be able to take care of some of these resources problems.
					</p>
					<p>
						By creating a platform and business model around providing time and access to join projects and
						build a professional trades career, ReVitalize reduces some of the barriers for their students.
					</p>
				</div>
			</div>
		</div>
	);
};

export default Main;
